/**
 * The device's IANA timezone name (issue #656): the ONE zone reader,
 * converged from the web export hook's browserTimeZone and the mobile
 * notifications module's deviceTimeZone — two byte-identical bodies
 * that had drifted into per-platform homes. Both apps' export flow
 * (./calendarExportFlow) and the mobile reminder planner resolve the
 * floating wall clock through this answer, so a floating reminder
 * concretizes the way THIS device reads it.
 *
 * Falls back to UTC rather than throwing on the rare engine without
 * Intl timezone support; an engine whose zone resolves empty reads
 * UTC too (both fallbacks pinned by test). Tests inject the zone
 * explicitly; only real devices read this.
 */
export function deviceTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
